import React from "react";
import { ICategoryCard } from "./interface";
import { AccentBar, CardTitle, CardWrapper, Content, IconWrapper } from "./styles";

const CategoryCard: React.FC<ICategoryCard> = ({
  title,
  icon,
  onClick,
  accentColor = "#6EE4D9",
}) => {
  return (
    <CardWrapper
      clickable={!!onClick}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={(e) => {
        if (onClick && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onClick();
        }
      }}
      data-testid={`category-card-${title.toLowerCase()}`}
    >
      <AccentBar color={accentColor} />
      <Content>
        <IconWrapper>
          <img src={icon} alt={title} />
        </IconWrapper>
        <CardTitle>{title}</CardTitle>
      </Content>
    </CardWrapper>
  );
};

export default CategoryCard;
